<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import AddEdit from "./addedit.vue";
import documents from "@/models/documents";
import { VueTreeList, Tree, TreeNode } from 'vue-tree-list';


export default {
  mixins: [apibtoast, apigeneric,documents],
  page: {
    title: "Talep",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    PageHeader,
    AddEdit,
    VueTreeList

  },
  data() {
    return {
      title: this.$t("documents.Title"),
      items: [
        {
          text: this.$t("documents.Page.Anasayfa"),
          href: "/",
        },
        {
          text: this.$t("documents.Page.UstMenu"),
          active: true,
        },
        {
          text: this.$t("documents.Title"),
          active: true,
        },
      ],

      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },

      parametreler:null,

      TableData: {},
      DataUpdate: "",
      AddEdit: "",
      newTree: {},
        data: new Tree([
          {
            name: 'Node 1',
            id: 1,
            pid: 0,
            dragDisabled: true,
            addTreeNodeDisabled: true,
            addLeafNodeDisabled: true,
            editNodeDisabled: true,
            delNodeDisabled: true,
            children: [
              {
                name: 'Node 1-2',
                id: 9,
                isLeaf: true,
                pid: 1
              }
            ]
          },
          {
            name: 'Node 2',
            id: 3,
            pid: 0,
            disabled: true
          },
          {
            name: 'Node 3',
            id: 4,
            pid: 0,
             children: [
              {
                name: 'Node 1-2',
                id: 5,
                isLeaf: true,
                pid: 4,
                children: [
                  {
                    name: 'Node 1-2',
                    id: 6,
                    isLeaf: true,
                    pid: 5
                  }]
              }
            ]
          }
        ]),
     
    json_list:[],
    };
  },
  methods: {
    Get() {
      let Filter = "";

      this.ActionsFilterGet({ Service: "Documents", Page: this.Page, Filter: Filter }).then((res) => {

        this.TableData = JSON.parse(res.Data);

        let pid="";

         this.json_list=[];
           
        for (var i=0; i<this.TableData.length;i++){

            if(this.TableData[i].topid==null || this.TableData[i].topid=="" ){

                this.json_list.push({id:this.TableData[i].id,name:this.TableData[i].title,pid:pid,
                typeid:this.TableData[i].typeid,addTreeNodeDisabled: true, addLeafNodeDisabled: true,dragDisabled: true})
            

            } 

        }

        let altliste=[];
        for ( i=0; i<this.json_list.length;i++){

            for(var s=0;s<this.TableData.length;s++){
                if (this.json_list[i].id==this.TableData[s].topid){

                    altliste.push({id:this.TableData[s].id, name:this.TableData[s].title,pid:pid,
                    typeid:this.TableData[s].typeid,addTreeNodeDisabled: true, addLeafNodeDisabled: true,dragDisabled: true})
                    pid+=1;             
     
                }
                
            } 

            if  (altliste.length>0){ 
                this.json_list[i].children=altliste;  
                altliste=[];          
            }
            
        }

        altliste=[];
        for ( i=0; i<this.json_list[0].children.length;i++){

            for( s=0;s<this.TableData.length;s++){
                if (this.json_list[0].children[i].id==this.TableData[s].topid){

                    altliste.push({id:this.TableData[s].id, name:this.TableData[s].title,pid:pid,
                    typeid:this.TableData[s].typeid,addTreeNodeDisabled: true, addLeafNodeDisabled: true,dragDisabled: true})
                    pid+=1;             
     
                }
                
            } 

            if  (altliste.length>0){ 
                this.json_list[0].children[i].children=altliste;  
                altliste=[];          
            }
            
        }


   
        this.data = new Tree(this.json_list);    

        this.Page.PageDataSize = this.TableData[0].totalcount;

      });

    },

    Guncelle(kayit_id){
          
     for (var i=0; i<this.TableData.length;i++){
      if(kayit_id==this.TableData[i].id){
        this.DataUpdate = this.TableData[i];
        }
     }

      this.AddEdit = 'Edit';

     // this.$refs['documents'].show();

    },
    ekle(){
      this.onAddNode();
    },

      addNode(pr) {
        var node = new TreeNode(pr)
        if (!this.data.children) this.data.children = []
        this.data.addChildren(node)
      },

    
      onDel(node) {
        console.log(node)
        node.remove()
      },
 
      onChangeName(params) {
        console.log(params)
      },
 
      onAddNode(params) {
        console.log(params)
        this.parametreler=params;
      },
 
      onClick(params) {
        console.log(params)
      },
 

      getNewTree() {
        var vm = this
        function _dfs(oldNode) {
          var newNode = {}
 
          for (var k in oldNode) {
            if (k !== 'children' && k !== 'parent') {
              newNode[k] = oldNode[k]
            }
          }
 
          if (oldNode.children && oldNode.children.length > 0) {
              newNode.children = []
              for (var i = 0, len = oldNode.children.length; i < len; i++) {
                newNode.children.push(_dfs(oldNode.children[i]))
              }
          }
          return newNode
        }
 
        vm.newTree = _dfs(vm.data)
      }
    },


};
</script>



<template>
  <Loader>
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-2">
          
                <div class="col-sm-12">
                  <div class="text-sm-end">
                     <button type="button" class="btn btn-primary btn-rounded mb-2 me-2" v-b-modal.documents @click="(DataUpdate = documentsData), (AddEdit = 'Add')"><i class="mdi mdi-plus me-1"></i>{{ $t("documents.Page.YeniKayitEkle") }}</button>
                  </div>
                </div>
              </div>

              <div>
   <!-- <button @click="addNode">Add Node</button> -->
    <vue-tree-list
      @click="onClick"
      @change-name="onChangeName"
      @add-node="onAddNode"
      :model="data"
      default-tree-node-name="new node"
      default-leaf-node-name="new leaf"
      v-bind:default-expanded="false"
    >
      <span class="icon" slot="addTreeNodeIcon">➕</span>
      <span class="icon" slot="addLeafNodeIcon">＋</span>     
      <span class="icon" slot="leafNodeIcon">🍃</span>

      <template v-slot:delNodeIcon="deleteProps">
      <span class="icon" slot="delNodeIcon"  @click="Delete('documents', deleteProps.model.id),Get()">🗑️</span>
      </template>

       <template v-slot:editNodeIcon="updateProps">
        <span class="icon" slot="editNodeIcon"  v-b-modal.documents  @click="Guncelle(updateProps.model.id)">✏️</span>
       </template>
      
       <template v-slot:treeNodeIcon="slotProps">
      <span v-if="slotProps.model.typeid=='1'" class="icon" slot="treeNodeIcon">📂</span> 
      <span v-if="slotProps.model.typeid=='2'" class="icon" slot="treeNodeIcon">📃</span>
      </template>
     
     
    </vue-tree-list>
    <!--<button @click="getNewTree">Get new tree</button>
    <pre>
      {{newTree}}
    </pre> -->
  </div>
        
{{parametreler}}
            </div>
          </div>
        </div>
      </div>

      



 <AddEdit :Id="DataUpdate" :AddEdit="AddEdit" @TableUpdate="Get()" />


      <!--         <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                    <tr>
                      <th>{{ $t("documents.Table.Dataorder") }}</th>
                      <th>{{ $t("documents.Table.Typeid") }}</th>
                      <th>{{ $t("documents.Table.Title") }}</th>
                       <th>Üst İd</th>
                     
                      <th style="width: 100px; text-align: center;">{{ $t("documents.Table.Islem") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="Data in TableData" :key="Data.Id">
                      <td>{{ Data.dataorder}}</td>        
                       <td>{{ Data.typeid}}</td>    

                      <td>{{ Data.title}}</td>
                       <td>{{ Data.topid}}</td>

                      <td style="width: 100px; text-align: center;">
                        <b-button-group>
                          <b-button variant="success" v-b-modal.documents @click="(DataUpdate = Data), (AddEdit = 'Edit')"><i class="far fa-edit"></i></b-button>
                          <b-button variant="danger" @click="Delete('documents', Data.id)"><i class="far fa-trash-alt"></i></b-button>
                        </b-button-group>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <br />
                <b-pagination class="pagination pagination-rounded justify-content-end mb-2" v-model="DefaultPage" 
                :total-rows="Page.PageDataSize" :per-page="Page.PageSize" aria-controls="my-table" 
                @input="ChangePage(DefaultPage)"> </b-pagination>
              </div> -->


    </Layout>
  </Loader>
</template>





